import { render, staticRenderFns } from "./ConfigModal.vue?vue&type=template&id=450306d0&scoped=true"
import script from "./ConfigModal.vue?vue&type=script&lang=ts"
export * from "./ConfigModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfigModal.vue?vue&type=style&index=0&id=450306d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450306d0",
  null
  
)

export default component.exports